import "./DatePicker.scss";

import { FunctionComponent } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DatePickerProps } from "./IDatePicker";

const DatePickers: FunctionComponent<DatePickerProps> = (props) => {
  const {
    label,
    disableFuture,
    disableOpenPicker,
    helperText,
    disableHighlightToday,
    disablePast,
    disabled,
    displayWeekNumber,
    readOnly,
    views,
    value,
    closeOnSelect,
    open,
    onClose,
    onOpen,
    openTo,
    maxDate,
    minDate,
    format,
    onChange,
    onFocus,
    onBlur,
    error,
    required,
    sx,
    className,
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        className={className}
        {...props}
        sx={sx}
        label={label}
        value={value}
        onChange={onChange}
        disableFuture={disableFuture}
        disableHighlightToday={disableHighlightToday}
        disableOpenPicker={disableOpenPicker}
        disablePast={disablePast}
        disabled={disabled}
        displayWeekNumber={displayWeekNumber}
        readOnly={readOnly}
        views={views}
        closeOnSelect={closeOnSelect}
        open={open}
        openTo={openTo}
        onClose={onClose}
        onOpen={onOpen}
        minDate={minDate!}
        maxDate={maxDate!}
        format={format}
        slotProps={{
          textField: {
            helperText: helperText,
            onFocus: onFocus,
            onBlur: onBlur,
            error: error,
            required: required,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePickers;
